import React from 'react';
import PropTypes from 'prop-types';

export const EmbeddedQuiz = ({ mediaType, source, disclaimer }) => {
  return (
    <div className="quiz-container">
      {/* If the media type is List, create an iframe with the embedded content  */}
      {mediaType === 'List' ? (
        <iframe src={source} height="700" width="100%" />
      ) : null}
      {mediaType === 'Quiz' ? (
        <iframe src={source} height="600" width="100%" />
      ) : null}
      <p className="xsmall disclaimer">{disclaimer && '*' + disclaimer}</p>
    </div>
  );
};

export default EmbeddedQuiz;

EmbeddedQuiz.propTypes = {
  mediaType: PropTypes.string,
  source: PropTypes.string,
  disclaimer: PropTypes.string,
};
